import {disableScroll, enableScroll} from '../../resources/js/utils/scroll';

document.body.addEventListener('click', function (e) {
  if (e.target.classList.contains('js-gallery-modal')) {
    const modalChild = e.target.querySelector('.gallery__modal');
    const modalContainer = modalChild.querySelector('.modal__container');
    if (modalChild) {
      e.target.classList.add('active');
      modalChild.classList.add('modal');
      fadeIn(modalChild);
      modalContainer.classList.add('modal-active');
      disableScroll();
    }
  }

  if (e.target.classList.contains('modal__close') || e.target.classList.contains('modal__container')) {
    const modalChild = e.target.closest('.gallery__modal');

    if (modalChild) {
      const modalContainer = modalChild.querySelector('.modal__container');
      const modalCloseElement = modalChild.querySelector('.modal__close');
      closeModal(modalCloseElement, modalChild, modalContainer);
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const activeModals = document.querySelectorAll('.modal__container.modal-active');

      if (activeModals.length > 0) {
        activeModals.forEach(modalContainer => {
          modalContainer.classList.remove('modal-active');
          modalContainer.closest('.gallery__modal').classList.remove('modal')

          enableScroll()
        });
      }
    }
  })
});

function closeModal(closeBtn, modalChild, modalContainer) {
  enableScroll()
  modalContainer.classList.remove('modal-active');
  modalChild.classList.remove('modal');
}

function fadeIn(el, duration = 400) {
  el.style.opacity = 0;
  el.style.display = "block";
  let last = performance.now();

  function tick(now) {
    let delta = now - last;
    el.style.opacity = +el.style.opacity + delta / duration;
    last = now;
    if (+el.style.opacity < 1) {
      requestAnimationFrame(tick);
    }
  }

  requestAnimationFrame(tick);
}
